"use strict";

import Global from "/js/core/global.js";
import Util from "/js/util/util.js";
import AppUtil from "/js/util/app-util.js";
import AnimSequencer from "/js/util/anim-sequencer.js";
import DragDelegate from "/js/util/drag-delegate.js";
import DragDropInteractionView from "/js/interaction-views/dragdrop-interaction-view.js"
/**
 * Is a little square card.
 */
export default class DragDropItemView {
  
  #$el;
  #$inner;
  #$flasher;

  #dragDelegate = null;

  #index;
  #targetBucket;
  #title;
  #currentBucket;

  #topBucketPosX;
  #topBucketPosY;

  #shouldDrag;
  #dragStartX;
  #dragStartY;
  #dragPosX;
  #dragPosY;

  constructor(data, index) {

    // TODO: When data.title looks like this "somelongword/somelongword", it doesn't wrap at the slash, so use a regex and insert a space, or smth.

    const s = `
        <div class="item">
          <div class="inner">
            <div class="content">${ data.title }</div>
          </div>
          <div class="flasher"></div>
        </div>
        `;
    this.#$el = $(s);

    this.#index = index;
    this.#targetBucket = data.target;
    this.#title = data.title;
    this.#currentBucket = "top";
    this.#$flasher = this.#$el.find(".flasher");

    this.#$inner = this.#$el.find(".inner");

    this.#dragDelegate = new DragDelegate(this, this.#$el);
    this.#dragDelegate.setCallbacks(
        this.#onDelegateDown, this.#onDelegateMove, this.#onDelegateUp, this.#onDelegateClick);
  }

  get $el() {
    return this.#$el;
  }

  get targetBucket() {
    return this.#targetBucket;
  }

  get currentBucket() {
    return this.#currentBucket;
  }

  set currentBucket(s) {
    this.#currentBucket = s;
  }

  get title() {
    return this.#title;
  }

  get contentWidth() {
    return this.#$inner.width();
  }

  /** 
   * Sets the position of the top bucket so the card knows how to drag itself (not ideal).
   */
  setTopBucketPos(x, y) {
    this.#topBucketPosX = x;
    this.#topBucketPosY = y;
  }

  /** 
   * Sets the order of the item in the stack, use for stacking visual effect. 
   * Use `-1` for "bucketed".
   */
  setPositionClass(positionIndex, dontAnimate=false) {
    const f = () => {
      this.removePositionClass();
      const cls = (positionIndex === -1) ? "bucketed" : ("pos"+ positionIndex);
      this.#$inner.addClass(cls);
      // Also set only the top-most card to be not aria-hidden.
      Util.setAriaHidden(this.#$el, (cls !== "pos0"));
    };
    if (dontAnimate) {
      AppUtil.setCssWithoutTransition(this.#$inner, f);
    } else {
      f();
    }
  }

  removePositionClass() {
    this.#$inner.removeClass("pos0 pos1 pos2 pos3 pos4 pos5 pos6 pos7 pos8 pos9 bucketed");
  }

  doFlash(isCorrect, callback) {
    // Set color.
    this.#$flasher.removeClass("correct incorrect showing");
    this.#$flasher.addClass(isCorrect ? "correct" : "incorrect");

    const seq = new AnimSequencer();
    seq.addAnim(this.#$flasher, () => { this.#$flasher.addClass("showing"); });
    seq.addAnim(this.#$flasher, () => { this.#$flasher.removeClass("showing"); });
    seq.setCallback(callback);
    seq.run();
  }

  #onDelegateDown(x, y) {
    /*
    if (!DragDelegate.isTouchDevice) {
      this.#shouldDrag = false;
      return;
    }
    */
    let b = (new Date().getTime() >= DragDropInteractionView.nextAllowedAnimTime);
    if (!b) {
      this.#shouldDrag = false;
      return;
    }
    b = this.#$inner.hasClass("pos0");
    if (!b) {
      this.#shouldDrag = false;
      return;
    }
    // User has pressed down on the top card in the top bucket; start the drag sequence.
    this.#shouldDrag = true;
    this.#dragStartX = x;
    this.#dragStartY = y;

    // Make sure card is top-most element.
    this.#$el.parent().append(this.#$el);
  }

  #onDelegateMove(deltaX, deltaY, didCrossThreshold) {  
    if (!this.#shouldDrag) {
      return;
    }
    AppUtil.setCssWithoutTransition(this.#$el, () => {
      this.#dragPosX = this.#topBucketPosX + (deltaX / Global.cardScale);
      this.#dragPosY = this.#topBucketPosY + (deltaY / Global.cardScale);
      this.#$el.css("left", this.#dragPosX);
      this.#$el.css("top", this.#dragPosY);
    });
  }

  #onDelegateUp(x, y, deltaX, deltaY) { 
    if (!this.#shouldDrag) {
      return;
    }
    // Send event; interaction will decide whether to move to a bucket, etc.
    this.#$el.trigger("dragdrop-item-up", { card: this, x: this.#dragPosX, y: this.#dragPosY });
  }

  #onDelegateClick(x, y, deltaX, deltaY) {
    // Send event and let the interaction decide what to do with it.
    this.#$el.trigger("dragdrop-item-click", this);
  }
}
